import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {BulkOrderService} from "../../bulk-ordering/bulk-order.service";
import {deliveryMethodValues} from "../../order/order-value-maps";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowService} from "../workflow.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {BulkOrderGqlModel} from "../../bulk-ordering/bulk-order.gql-model";

@Component({
  templateUrl: "./bulk-order-details.template.pug",
  providers: [BulkOrderService],
})
export class BulkOrderWFDetails extends WorkflowStep {
  error: Error;
  bulkOrder: BulkOrderGqlModel = new BulkOrderGqlModel({});

  deliveryMethodValues: any = Object.keys(deliveryMethodValues)
    .map(k => ([k, deliveryMethodValues[k]]));

  @handleErrors()
  async loadData() {
    this.bulkOrder = await this.bulkOrderService.getById(this.workflowService.workflowConfig.targetId);
  }

  ready() {
    this.loadData();
  }

  constructor(
    private bulkOrderService: BulkOrderService,
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.bulkOrderService.save(this.bulkOrder);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  checkDirty(): boolean {
    return this.bulkOrder.form.dirty;
  }
}
